module.exports = __webpack_public_path__ + "img/index-banner1.c7693f60.jpg";